import { createApiClient, type ApiClient } from "./client";
import { getDeviceId } from "../lib/device";
import { tg } from "../telegram";

const TOKEN_KEY = "gxr.token";

let token: string | null = sessionStorage.getItem(TOKEN_KEY);
let loginPromise: Promise<void> | null = null;

export const api: ApiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL,
  getToken: () => token,
  deviceId: getDeviceId(),
  onUnauthorized: () => {
    token = null;
    sessionStorage.removeItem(TOKEN_KEY);
  },
});

/** Exchange Telegram initData for a JWT. Idempotent while in flight. */
export function login(): Promise<void> {
  if (loginPromise) return loginPromise;
  loginPromise = (async () => {
    const initData = tg.initData;
    if (!initData) throw new Error("NO_INIT_DATA");
    const res = await api.post<{ token: string }>("/auth/telegram", { initData });
    token = res.token;
    sessionStorage.setItem(TOKEN_KEY, token);
  })().finally(() => {
    loginPromise = null;
  });
  return loginPromise;
}

export function hasSession(): boolean {
  return token !== null;
}

/** Run a request; on a 401, log in once and retry. */
export async function withAuth<T>(fn: () => Promise<T>): Promise<T> {
  if (!token) await login();
  try {
    return await fn();
  } catch (err) {
    if (err instanceof Error && "status" in err && (err as { status: number }).status === 401) {
      await login();
      return fn();
    }
    throw err;
  }
}
